import PropTypes from "prop-types";

// material-ui
import { Box, Stack } from "@mui/material";

// project import
import { CloseOutlined } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import AnimateButton from "../../components/@extended/AnimateButton";
import MainCard from "../../components/MainCard";
import { setModalCloser } from "../../stateManagement/reducers/menuReducer";

// ==============================|| AUTHENTICATION - CARD WRAPPER ||============================== //

const AuthCard = ({ children, maxWidth = 475, ...other }) => {
  const dispatch = useDispatch();
  const { openModal } = useSelector((state) => state.menu);

  return (
    <MainCard
      className="shadow"
      sx={{
        maxWidth: { xs: 400, md: maxWidth },
        margin: { xs: 2.5, md: 3 },
        overflowX: "hidden",
        "& > *": {
          flexGrow: 1,
          flexBasis: "50%",
        },
      }}
      content={false}
      {...other}
      border={false}
      boxShadow
    >
      {openModal && (
        <Stack
          justifyContent="space-between"
          alignItems="flex-end"
          p={1}
          style={{ position: "relative", zIndex: 10000000 }}
        >
          <AnimateButton>
            <CloseOutlined
              style={{
                fontSize: "2rem",
                color: "red",
                "&:hover": { cursor: "pointer !important" },
              }}
              onClick={() => {
                const thaFunc = openModal;
                thaFunc(false);
                dispatch(setModalCloser(null));
              }}
            />
          </AnimateButton>
        </Stack>
      )}
      <Box mt={openModal ? -2 : 0} sx={{ p: { xs: 2, sm: 3, md: 3, xl: 3 } }}>
        {children}
      </Box>
    </MainCard>
  );
};

AuthCard.propTypes = {
  children: PropTypes.node,
};

export default AuthCard;
